import { inject as service } from '@ember/service';
import ApplicationAdapter from 'cio/adapters/application';
import EnvironmentService from 'cio/services/environment';

export default class IntegrationsCdpOutAdapter extends ApplicationAdapter {
  @service environment!: EnvironmentService;

  // Build URLs in the format: /v1/environments/:id/integrations/cdp_out
  pathForType() {
    if (this.environment.current.id == null) {
      throw new Error('`environment` needs to be initialized before making a request to fetch an integration');
    }

    return `environments/${encodeURIComponent(this.environment.current.id)}/integrations/cdp_out`;
  }
}
